module.exports = "/static/assets/1c8c4a50da40b5cc2c646815412a601e.png";